import React, { useEffect, useState } from "react";
import MainLayout from "../../components/layout/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Login from "../../app/auth/Login";
import TableIdentities from "../../components/reuseable/TableIdentities";
import Table from "../../components/reuseable/Table";

import "./Details.scss";
import {
  FaRegTimesCircle,
  FaTimesCircle,
  FaLink,
  FaTools,
} from "react-icons/fa";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Card from "../../components/reuseable/Card";
import { useLocation } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

const Details = () => {
  const [outputData, setoutputData] = useState();
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const responseID = queryParams.get("responseID");

 

  
  const getOutputData = async () => {
    setloading(true);
    const url = `${process.env.REACT_APP_PYTHON_BACKEND_URL}/output/${responseID}`;

    await fetch(`${url}`)
      .then((response) => {
        if (response.status === 200) {
          response.json().then((json) => {
            console.log(json);
            setoutputData(json);
            setloading(false);
          });
        }
      })
      .catch((err) => {
        setloading(false);
        seterror(true);
        console.log(err);
      });
  };

  useEffect(() => {
    getOutputData();
  }, []);

  const compliance_assessment_header = [
    "Policy Section",
    "Compliance Status",
    "Observations",
  ];

  const identified_violations_header = [
    "Non Compliance",
    "Reason",
    "Suggestion",
   
    
  ];

  return (
    <>
      <AuthenticatedTemplate>
        <div
          id="homePage"
          style={{ overflow: "hidden", height: "var(--app-height)" }}
        >
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />

              <div id="mainHome">
                <div style={{ overflow: "auto", height: "100%" }}>
                  <div
                    style={{ marginTop: "2rem", maxWidth: "90%" }}
                    class="container"
                  >
                    <div style={{ display: "grid", gap: "1rem" }}>
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ fontWeight: "500", fontSize: "14px",display:"grid",alignContent:"center",alignItems:"center" }}>
                        <span>
                          Sender: {loading ? <Skeleton width={500} height={20}/> :<b>{outputData && outputData['data'] && outputData['data']['email_details'] && outputData['data']['email_details']['sender']}</b> }

                          </span>
                        
                          <span>
                          Subject:   {loading ? <Skeleton width={500} height={20}/> : <b>{outputData && outputData['data'] && outputData['data']['email_details'] && outputData['data']['email_details']['subject']}</b> }

                          </span>
                         
                         

                        </span>
                        <span
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ fontSize: "16px", fontWeight: "500",display:"flex",gap:"10px" }}>
                          {loading ? <Skeleton width={100} height={30}/>:'Compliance Score​: '}    
                          </span>

                          {loading ? <Skeleton style={{borderRadius:"100%"}} width={30} height={30}/> : 
                          
                          <span
                          style={{
                            width: "30px",
                            height: "30px",
                            // background: `${outputData['data']['executive_summary'] && outputData['data']['executive_summary']['compliance_score'] <=5 ? "red" : "green"}`,
                            display: "block",
                            borderRadius: "100%",
                            textAlign:"center",
                            alignContent:"center",
                            alignItems:"center",
                            color:"white",
                            background: `${outputData && outputData['data']['executive_summary'] && outputData['data']['executive_summary']['compliance_score'] 
                              ? outputData && outputData['data']['executive_summary'] && outputData['data']['executive_summary']['compliance_score'] <= 5 
                                ? "red" 
                                : outputData && outputData['data']['executive_summary'] && outputData['data']['executive_summary']['compliance_score'] <= 8 
                                  ? "#f18b38" 
                                  : "green" 
                              : "green"}`
                          }}
                        >
{outputData && outputData['data'] && outputData['data']['executive_summary'] && outputData['data']['executive_summary']['compliance_score']
}
                        </span>
                          }

                         
                        </span>
                      </span>

                      <div style={{ display: "grid", gap: "5px" }}>
                        <span style={{ fontWeight: "600" }}>
                          {" "}
                          <FaLink style={{ fontSize: "14px" }} /> Summary
                        </span>
                        <span>
                        {loading ? <Skeleton count={3} width="100%" height={20}/> : 
                        <span style={{backgroundColor:"#eee",padding:"10px",borderRadius:"6px",paddingTop:"10px",display:"block",width:"auto"}}>
{                          outputData && outputData['data'] && outputData['data']['executive_summary'] && outputData['data']['executive_summary']['critical_issues_summary']
}                          
                        </span> }

                        </span>
                      </div>

                      <div style={{ display: "grid", gap: "5px" }}>
                        <span
                          style={{ fontWeight: "600", paddingBottom: "10px" }}
                        >
                          {" "}
                          <FaLink style={{ fontSize: "14px" }} /> Assessment by
                          policy section​
                        </span>
                        <span>
                          <Table
                            headersData={compliance_assessment_header}
                            header="bg-c-orange-table"
                            tableData={
                              outputData &&
                              outputData["data"]["compliance_assessment"]
                            }
                            loading={loading}
                          />
                        </span>
                      </div>

                      <div style={{ display: "grid", gap: "5px" }}>
                        <span
                          style={{ fontWeight: "600", paddingBottom: "10px" }}
                        >
                          {" "}
                          <FaLink style={{ fontSize: "14px" }} /> Suggested
                          revised email​
                        </span>

                        <span
                          style={{
                            fontWeight: "600",
                            paddingBottom: "10px",
                            fontSize: "14px",
                          }}
                        >
                          {loading ?  <Skeleton width={200} height={20}/> : ' Identified violations'}
                         
                        </span>

                        {loading ?  <Skeleton width="100%" height={100} count={3}/> :

                          <>
                           {/* {outputData &&
                          outputData["data"] &&
                          outputData["data"]["identified_violations"].map(
                            (item, index) => {
                              return (
                                <div
                                  style={{
                                    display: "grid",
                                    gap: "5px",
                                    background: "#eee",
                                    padding: "10px",
                                    borderRadius: "6px",
                                  }}
                                  key={index}
                                >
                                  <span style={{ fontSize: "14px" }}>
                                  <b>Non Compliant Segment:</b>  {item.non_compliant_segment}
                                  </span>

                                  <span style={{ fontSize: "14px" }}>
                                  <b>Compliant Suggestion:</b>  {item.compliant_suggestion}
                                  </span>

                                  <span
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                               <b>Violation Reason:</b>   violation_reason   {item.violation_reason}
                                  </span>
                                </div>
                              );
                            }
                          )} */}

                          <TableIdentities
                            headersData={identified_violations_header}
                            header="bg-c-orange-table"
                            tableData={
                              outputData &&
                              outputData["data"]["identified_violations"]
                            }
                            loading={loading}
                          />
                          </>
                          }

                        {/* <span
                          style={{
                            fontWeight: "600",
                            paddingBottom: "10px",
                            fontSize: "14px",
                            paddingTop: "1rem",
                          }}
                        >
                          
                          {loading ?  <Skeleton width={200} height={20}/> : 'Suggested Corrections'}

                        </span>
                        {loading ?  <Skeleton width="100%" height={100} count={3}/>  : <>
                        

                        {outputData &&
                          outputData["data"] &&
                          outputData["data"]["suggested_corrections"].map(
                            (item, index) => {
                              return (
                                <div
                                  style={{
                                    display: "grid",
                                    gap: "5px",
                                    background: "#eee",
                                    padding: "10px",
                                    borderRadius: "6px",
                                  }}
                                  key={index}
                                >
                                  <span style={{ fontSize: "14px" }}>
                                    {item.non_compliant}
                                  </span>

                                  <span style={{ fontSize: "14px" }}>
                                    {item.compliant_suggestion}
                                  </span>
                                </div>
                              );
                            }
                          )}
                                                  </>} */}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default Details;
